<script>
    export default {
    page: {
        titleTemplate(title) {
          title = typeof title === 'function' ? title(this.$store) : title
          return `${this.appconfig.title} - ${title}`
        },
    },
    mounted:function (){}
    }
</script>
<template>
  <div id="app">
    <RouterView :key="$route.fullPath" />
  </div>
</template>
<style lang="scss">
    @import '@design';
</style>